import { FiSearch } from "react-icons/fi";
import { useState, useEffect, useMemo, useRef } from "react";
import { Button, Form, Table } from "react-bootstrap";
import { NoDataFoundTable } from "../../../Hooks/NoDataFoundTable";
import { formServices } from "../../../APIServices/VoultManagement/formServices";
import {
  FaEdit,
  FaLock,
  FaLockOpen,
  FaPlus,
  FaRegTrashAlt,
  FaTrashAlt,
} from "react-icons/fa";
import Swal from "sweetalert2";
import UseToggle from "../../../Hooks/UseToggle";
import Pagination from "../../../Hooks/Pagination";
import AddNewFormMeta from "./AddNewFormMeta";
import UpdateFormMeta from "./UpdateFormMeta";
import DeletedFormMetadata from "./DeletedFormMetadata";
import Moment from "react-moment";
import { categoryServices } from "../../../APIServices/VoultManagement/categoryServices";
import FormEditor from "./FormEditor";
import FormPreview from "./FormPreview";

const FormMetaManagement = () => {
  const AppRef = useRef(null);
  const toggles = UseToggle();

  const [searchData, setSearchData] = useState("");
  const [formMetaList, setFormMetaList] = useState([]);
  const [formMetaCount, setFormMetaCount] = useState(0);

  const [deletedFormMeta, setDeletedFormMeta] = useState([]);
  const [deletedFormMetaCount, setDeletedFormMetaCount] = useState(0);

  const [formMetadata, setFormMetadata] = useState("");
  const [openPreview, setOpenPreview] = useState(false);
  const [openModule, setOpenModule] = useState("preview");
  const [categoryMetaList, setCategoryMetaList] = useState([]);

  const [pageNumber, setPageNumber] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const startIndex = (pageNumber - 1) * itemsPerPage;
  const totalPage = Math.ceil(formMetaCount / itemsPerPage);

  const [pageNumberDeleted, setPageNumberDeleted] = useState(1);
  const [itemsPerPageDeleted, setItemsPerPageDeleted] = useState(10);

  const [openList, setOpenList] = useState(false);
  const [fieldList, setFieldList] = useState([]);

  const getFormMetaList = async () => {
    let data = await formServices.getFormMetaList(
      "active",
      searchData,
      pageNumber,
      itemsPerPage
    );
    setFormMetaList(data?.data || []);
    setFormMetaCount(data?.count || 0);
  };

  const getDeletedFormMetaList = async () => {
    let data = await formServices.getFormMetaList(
      "deleted",
      "",
      pageNumberDeleted,
      itemsPerPageDeleted
    );
    setDeletedFormMeta(data?.data || []);
    setDeletedFormMetaCount(data?.count || 0);
  };

  const softDeleteRestoreFormMeta = async (formId, type) => {
    Swal.fire({
      title: "Are you sure?",
      text: `You want to ${type} Form metadata?`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: `Yes, ${type} it!`,
    }).then(async (result) => {
      if (!result.isConfirmed) return;
      const userData = { formId, type };
      const data = await formServices.softDeleteRestoreFormMeta(userData);
      if (data?.statusCode === 200) {
        getFormMetaList();
        getDeletedFormMetaList();
      }
    });
  };

  const updatedLockFormMeta = async (formId, lockStatus) => {
    Swal.fire({
      title: "Are you sure?",
      text: `You want to ${lockStatus ? "lock" : "unlock"} metadata?`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes",
    }).then(async (result) => {
      if (!result.isConfirmed) return;
      const userData = { formId, lockType: true, lockStatus };
      const data = await formServices.updatedFormMeta(userData);
      if (data?.statusCode === 200) getFormMetaList();
    });
  };

  const [loader, setLoader] = useState(false);

  const updatedFormMeta = async () => {
    Swal.fire({
      title: "Are you sure?",
      text: "You want to update Form Fields?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, update it!",
    }).then(async (result) => {
      if (!result.isConfirmed) return;
      setLoader(true);
      const userData = {
        formId: formMetadata?.formId,
        fields: fieldList,
        fieldsType: true,
      };
      const data = await formServices.updatedFormMeta(userData);
      if (data?.statusCode === 200) {
        getFormMetaList();
        getSingleFormMeta()
      }
      setLoader(false);
    });
  };

  const getCategoryList = async () => {
    let data = await categoryServices.getCategoryList(
      "active",
    );
    setCategoryMetaList(data?.data || []);
  };

  useEffect(() => {
    getCategoryList();
  }, []);

  useEffect(() => {
    getFormMetaList();
  }, [searchData, pageNumber, itemsPerPage]);

  const activityLogs = [
    {
      _id: "685fe349e3572b7f40c4253a",
      uniqueId: "4159063841",
      activityBy: "fgifa9202089",
      form: "studyeventformschema",
      activities: "Schema Name have been successfully added to the Schema.",
      updatedValue: "Schema001",
      actionType: "add",
      __v: 0,
      createdAt: "2025-06-28T12:42:49.480Z",
      updatedAt: "2025-06-28T12:42:49.480Z",
      fullName: "Gaurav Chauhan"
    },
    {
      _id: "685fe349e3572b7f40c4253b",
      uniqueId: "4159063841",
      activityBy: "fgifa9202089",
      form: "studyeventformschema",
      activities: "Assign Date have been successfully added to the Schema.",
      updatedValue: "2025-06-18",
      actionType: "add",
      __v: 0,
      createdAt: "2025-06-28T12:42:49.480Z",
      updatedAt: "2025-06-28T12:42:49.480Z",
      fullName: "Gaurav Chauhan"
    },
    {
      _id: "685fe38ce3572b7f40c42594",
      uniqueId: "9221752978",
      activityBy: "fgifa9202089",
      form: "eventMetadata",
      activities: "Column Label has been successfully added to the event metadata.",
      updatedValue: "Event Number",
      actionType: "add",
      __v: 0,
      createdAt: "2025-06-28T12:43:56.257Z",
      updatedAt: "2025-06-28T12:43:56.257Z",
      fullName: "Gaurav Chauhan"
    },
    {
      _id: "685fe38ce3572b7f40c42595",
      uniqueId: "9221752978",
      activityBy: "fgifa9202089",
      form: "eventMetadata",
      activities: "Column Name has been successfully added to the event metadata.",
      updatedValue: "EVENNUM",
      actionType: "add",
      __v: 0,
      createdAt: "2025-06-28T12:43:56.257Z",
      updatedAt: "2025-06-28T12:43:56.257Z",
      fullName: "Gaurav Chauhan"
    },
    {
      _id: "685fe38ce3572b7f40c42596",
      uniqueId: "9221752978",
      activityBy: "fgifa9202089",
      form: "eventMetadata",
      activities: "Column Type has been successfully added to the event metadata.",
      updatedValue: "text",
      actionType: "add",
      __v: 0,
      createdAt: "2025-06-28T12:43:56.257Z",
      updatedAt: "2025-06-28T12:43:56.257Z",
      fullName: "Gaurav Chauhan"
    },
    {
      _id: "685fe39ae3572b7f40c4259b",
      uniqueId: "8479077403",
      activityBy: "fgifa9202089",
      form: "eventMetadata",
      activities: "Column Label has been successfully added to the event metadata.",
      updatedValue: "Event Name",
      actionType: "add",
      __v: 0,
      createdAt: "2025-06-28T12:44:10.999Z",
      updatedAt: "2025-06-28T12:44:10.999Z",
      fullName: "Gaurav Chauhan"
    },
    {
      _id: "685fe39ae3572b7f40c4259c",
      uniqueId: "8479077403",
      activityBy: "fgifa9202089",
      form: "eventMetadata",
      activities: "Column Name has been successfully added to the event metadata.",
      updatedValue: "EVENTNAM",
      actionType: "add",
      __v: 0,
      createdAt: "2025-06-28T12:44:10.999Z",
      updatedAt: "2025-06-28T12:44:10.999Z",
      fullName: "Gaurav Chauhan"
    },
    {
      _id: "685fe39ae3572b7f40c4259d",
      uniqueId: "8479077403",
      activityBy: "fgifa9202089",
      form: "eventMetadata",
      activities: "Column Type has been successfully added to the event metadata.",
      updatedValue: "text",
      actionType: "add",
      __v: 0,
      createdAt: "2025-06-28T12:44:10.999Z",
      updatedAt: "2025-06-28T12:44:10.999Z",
      fullName: "Gaurav Chauhan"
    },
    {
      _id: "685fe3b0e3572b7f40c425b2",
      uniqueId: "2902156162",
      activityBy: "fgifa9202089",
      form: "eventData",
      activities: "Event Id have been successfully added.",
      updatedValue: "V0_SCR",
      actionType: "add",
      __v: 0,
      createdAt: "2025-06-28T12:44:32.481Z",
      updatedAt: "2025-06-28T12:44:32.481Z",
      fullName: "Gaurav Chauhan"
    },
    {
      _id: "685fe3b0e3572b7f40c425b3",
      uniqueId: "2902156162",
      activityBy: "fgifa9202089",
      form: "eventData",
      activities: "Event Label have been successfully added.",
      updatedValue: "Screening",
      actionType: "add",
      __v: 0,
      createdAt: "2025-06-28T12:44:32.481Z",
      updatedAt: "2025-06-28T12:44:32.481Z",
      fullName: "Gaurav Chauhan"
    },
    {
      _id: "685fe3b0e3572b7f40c425b4",
      uniqueId: "2902156162",
      activityBy: "fgifa9202089",
      form: "eventData",
      activities: "Event Day have been successfully added.",
      updatedValue: "-30",
      actionType: "add",
      __v: 0,
      createdAt: "2025-06-28T12:44:32.481Z",
      updatedAt: "2025-06-28T12:44:32.481Z",
      fullName: "Gaurav Chauhan"
    },
    {
      _id: "685fe3b0e3572b7f40c425b5",
      uniqueId: "2902156162",
      activityBy: "fgifa9202089",
      form: "eventData",
      activities: "Event Name have been successfully added.",
      updatedValue: "Screening",
      actionType: "add",
      __v: 0,
      createdAt: "2025-06-28T12:44:32.481Z",
      updatedAt: "2025-06-28T12:44:32.481Z",
      fullName: "Gaurav Chauhan"
    },
    {
      _id: "685fe3b1e3572b7f40c425c2",
      uniqueId: "9112213509",
      activityBy: "fgifa9202089",
      form: "eventData",
      activities: "Event Id have been successfully added.",
      updatedValue: "V1_D0",
      actionType: "add",
      __v: 0,
      createdAt: "2025-06-28T12:44:33.673Z",
      updatedAt: "2025-06-28T12:44:33.673Z",
      fullName: "Gaurav Chauhan"
    },
    {
      _id: "685fe3b1e3572b7f40c425c3",
      uniqueId: "9112213509",
      activityBy: "fgifa9202089",
      form: "eventData",
      activities: "Event Label have been successfully added.",
      updatedValue: "Visit 1 Day 0",
      actionType: "add",
      __v: 0,
      createdAt: "2025-06-28T12:44:33.673Z",
      updatedAt: "2025-06-28T12:44:33.673Z",
      fullName: "Gaurav Chauhan"
    },
    {
      _id: "685fe3b1e3572b7f40c425c4",
      uniqueId: "9112213509",
      activityBy: "fgifa9202089",
      form: "eventData",
      activities: "Event Day have been successfully added.",
      updatedValue: "0",
      actionType: "add",
      __v: 0,
      createdAt: "2025-06-28T12:44:33.673Z",
      updatedAt: "2025-06-28T12:44:33.673Z",
      fullName: "Gaurav Chauhan"
    }
  ]

  const FormActivity = useMemo(() => {
    const grouped = {};

    activityLogs.forEach((item) => {
      const date = new Date(item.createdAt).toISOString().split("T")[0];
      if (!grouped[date]) grouped[date] = [];

      grouped[date].push({
        module: item.form || "Unknown Module",
        type: item.actionType || "Unknown Type",
        activities: item.activities,
        prevoiusValue: item.prevoiusValue,
        updatedValue: item.updatedValue,
        activityByName: item.fullName,
        createdAt: item.createdAt,
      });
    });

    return Object.entries(grouped)
      .map(([date, data]) => ({
        date,
        data: data.sort(
          (a, b) => new Date(b.createdAt) - new Date(a.createdAt)
        ),
      }))
      .sort((a, b) => new Date(b.date) - new Date(a.date));
  }, [activityLogs]);

  const getSingleFormMeta = async () => {
    let data = await formServices.getSingleFormMeta(formMetadata?.formId);
    setFieldList(data?.data?.fields || []);
  };

  useEffect(() => {
    if (formMetadata) {
      getSingleFormMeta()
    }
  }, [formMetadata]);

  return (
    <div style={{ background: "#eee" }}>
      <div className="p-2 d-flex gap-2">
        <div className={`meta-table overflow-auto ${openPreview ? "formShrink" : ""}`} style={{ height: "calc(100vh - 71px)" }}>
          <div className="hstack gap-2 pb-2 bg-white">
            <Button
              size="sm"
              variant="outline-primary"
              className="hstack gap-2 text-nowrap rounded-1 border"
              style={{ fontSize: 13 }}
              onClick={toggles.setToggle}
            >
              <FaPlus /> Add New Form
            </Button>
            <div className="search-box position-relative w-100">
              <FiSearch />
              <Form.Control
                type="search"
                className="w-100 rounded-1"
                style={{ fontSize: 13 }}
                placeholder="Search..."
                value={searchData}
                onChange={(e) => setSearchData(e.target.value)}
              />
            </div>
            {deletedFormMetaCount > 0 && (
              <Button
                size="sm"
                variant="outline-danger"
                className="hstack gap-2 text-nowrap rounded-1 border"
                style={{ fontSize: 13 }}
                onClick={toggles.setToggle2}
              >
                <FaRegTrashAlt /> Deleted History
              </Button>
            )}
          </div>
          <div className="overflow-auto" style={{ height: "calc(100vh - 122px)"}}>
            {formMetaCount === 0 ? (
              <NoDataFoundTable MSG="No Form Metadata." />
            ) : (
              <>
                <Table hover responsive className="">
                  <thead className="position-sticky" style={{ top: -1 }}>
                    <tr>
                      <th style={{ width: 45 }} className="text-center">Sr.</th>
                      <th>Name</th>
                      <th>Category</th>
                      <th className="text-center">Lock</th>
                      <th className="text-center" style={{ width: 80 }}>Actions</th>
                    </tr>
                  </thead>

                  <tbody>
                    {formMetaList.map((item, index) => (
                      <tr
                        key={item.formId}
                        className={formMetadata?.formId === item.formId ? "selectedRow CP" : "CP"}
                        onClick={() => {
                          setOpenPreview(true);
                          setFormMetadata(item);
                          setOpenModule("preview");
                        }}
                      >
                        <td className="text-center">{startIndex + index + 1}</td>
                        <td>
                          <strong>{item.name}</strong>
                          <div className="sub-text">{item.fieldCount}</div>
                        </td>
                        <td>
                          {item.category}
                        </td>
                        <td
                          className="text-center CP"
                          title="Lock Status"
                          onClick={(e) => {
                            e.stopPropagation();
                            updatedLockFormMeta(item.formId, !item.lockStatus);
                          }}
                        >
                          {item.lockStatus ? (
                            <FaLock className="text-success" />
                          ) : (
                            <FaLockOpen className="text-danger" />
                          )}
                        </td>

                        <td className="text-center actions">
                          <FaEdit
                            title="Edit"
                            className={`icon CP ${item.lockStatus ? "disabled" : ""}`}
                            onClick={(e) => {
                              e.stopPropagation();
                              if (!item.lockStatus) {
                                toggles.setToggle1();
                              }
                            }}
                          />

                          <FaTrashAlt
                            title="Delete"
                            className={`icon danger CP ${item.lockStatus ? "disabled" : ""}`}
                            onClick={(e) => {
                              e.stopPropagation();
                              if (!item.lockStatus) {
                                softDeleteRestoreFormMeta(
                                  item.formId,
                                  "delete"
                                );
                              }
                            }}
                          />
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </Table>
                <div className="position-sticky bottom-0 start-0">
                  <Pagination
                    totalPage={totalPage}
                    pageNumber={pageNumber}
                    itemsPerPage={itemsPerPage}
                    totalItems={formMetaCount}
                    setPageNumber={setPageNumber}
                    setItemsPerPage={setItemsPerPage}
                  />
                </div>
              </>
            )}
          </div>
        </div>

        {openPreview && (
          <div className="formMeta-preview">
            <div className="preview-header hstack justify-content-between">
              <div className="hstack gap-2">
                <Button size="sm" variant={openModule === "preview" ? "primary" : "outline-primary"} onClick={() => setOpenModule("preview")}>Preview</Button>
                <Button size="sm" variant={openModule === "editor" ? "primary" : "outline-primary"} onClick={() => setOpenModule("editor")}>Editor</Button>
                <Button size="sm" variant={openModule === "activity" ? "primary" : "outline-primary"} onClick={() => setOpenModule("activity")}>Activity</Button>
              </div>
              <div className="hstack gap-2">
                {openModule === "editor" && !formMetadata?.lockStatus &&
                  <Button size="sm" variant={openList ? "primary" : "outline-primary"} onClick={() => setOpenList(!openList)}>Add New</Button>
                }
                <Button size="sm" variant="outline-danger" onClick={() => { setOpenPreview(false); }}>Close</Button>
              </div>
            </div>

            {openModule === "preview" && (
              <div className="overflow-auto" style={{ height: "calc(100vh - 123px)" }}>
                {fieldList?.length > 0 ?
                  <FormPreview
                    fieldList={fieldList}
                  />
                  :
                  <NoDataFoundTable MSG="No Form Field." />
                }
              </div>
            )}
            {openModule === "editor" && (
              <>
                <div className="overflow-auto" style={{ height: `calc(100vh - ${formMetadata?.lockStatus ? "123" : "173"}px)` }}>
                  <FormEditor
                    setOpenList={setOpenList}
                    openList={openList}
                    setFieldList={setFieldList}
                    fieldList={fieldList}
                    AppRef={AppRef}
                    formMetadata={formMetadata}
                  />
                </div>
                {!formMetadata?.lockStatus &&
                  <div className="preview-footer">
                    <Button
                      disabled={loader}
                      onClick={updatedFormMeta}
                      variant="outline-primary"
                      style={{ fontSize: 13 }}
                      className="rounded-2 py-1 px-3"
                    >
                      {loader ? "Updating..." : "Update"}
                    </Button>
                  </div>
                }
              </>
            )}
            {openModule === "activity" && (
              <div className="p-2 bg-light overflow-auto" style={{ height: "calc(100vh - 123px)" }}>
                {FormActivity.map(({ date, data }, index) => (
                  <div key={index}>
                    {data?.map((item, key) => (
                      <div key={key} className="activity__section">
                        <div className="w-100">
                          <p style={{ fontSize: 12 }} className="m-0">Previous Value : {item?.previousValue}</p>
                          <p style={{ fontSize: 12 }} className="mb-1">Updated Value : {item?.updatedValue}</p>
                          <ul className="m-0 p-0">
                            <li>
                              <p className="m-0 text-muted" style={{ fontSize: 12 }}>
                                <span className="text-capitalize" style={{ fontWeight: 600 }}>
                                  {item.type}{": "}
                                </span>
                                {item.activities}
                              </p>
                            </li>
                          </ul>
                          <div className="mt-1 d-flex justify-content-between">
                            <Form.Label className="m-0 text-muted" style={{ fontSize: 12 }}>
                              <Moment format="DD MMM YYYY | HH:mm" withTitle>
                                {item?.createdAt}
                              </Moment>
                            </Form.Label>
                            <Form.Label className="m-0 text-muted" style={{ fontSize: 12 }}>
                              By: {item?.activityByName}
                            </Form.Label>
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                ))}
              </div>
            )}
          </div>
        )}
      </div>

      <AddNewFormMeta
        Show={!toggles.toggle}
        Hide={toggles.setToggle}
        Title={`Add New Form`}
        getFormMetaList={getFormMetaList}
        categoryMetaList={categoryMetaList}
      />

      <UpdateFormMeta
        Show={!toggles.toggle1}
        Hide={toggles.setToggle1}
        Title={`Update Form`}
        formMetadata={formMetadata}
        getFormMetaList={getFormMetaList}
        categoryMetaList={categoryMetaList}
      />

      <DeletedFormMetadata
        Show={!toggles.toggle2}
        Hide={toggles.setToggle2}
        Title={`Restore Forms`}
        deletedFormMeta={deletedFormMeta}
        softDeleteRestoreFormMeta={softDeleteRestoreFormMeta}
        deletedFormMetaCount={deletedFormMetaCount}
        pageNumberDeleted={pageNumberDeleted}
        itemsPerPageDeleted={itemsPerPageDeleted}
        setPageNumberDeleted={setPageNumberDeleted}
        setItemsPerPageDeleted={setItemsPerPageDeleted}
        getDeletedFormMetaList={getDeletedFormMetaList}
      />
    </div>
  );
};

export default FormMetaManagement;
